// extracted by mini-css-extract-plugin
module.exports = {"market":"Market_market__3Fszi","table":"Market_table__QG9cj","row":"Market_row__1uZ8v","col":"Market_col__30mqt","foot":"Market_foot__2LWmQ","arrow":"Market_arrow__3vobm"};